/* UI-DESIGN: sample player for previewing the /passport design without a
   backend. Hit /passport?preview=sample to load it. The page reads from
   the Redux store normally; this is a frontend-only fallback only used
   when the preview flag is present. Delete when the backend is live. */
import type { Player } from "../../types/game";

export const SAMPLE_PLAYER: Player = {
  objectId: "sample-player-iris-plum",
  name: "You",
  phone_number: "+15555550100",
  email: "you@example.com",
  interrogation_tokens: 3,
  email_sent: true,
  attendance: true,
  round_updates: [
    "Marina staff confirm Dr. Plum was last seen near the cabana at 21:47. Her medical bag was found on the spa terrace, unopened.",
    "The hotel concierge contradicts your earlier alibi. The bartender corroborates yours — but only partially.",
    "An anonymous note in your room reads: \"You were not the only one who knew about the prescription. Stay quiet, or you will be next.\"",
  ],
  role: {
    objectId: "sample-role-iris-plum",
    name: "Dr. Iris Plum",
    description:
      "The resort's reclusive medical director. Discreet, methodical, and far too curious about other people's secrets.",
    character_info:
      "You arrived at the White Lotus three years ago under circumstances you'd rather not discuss. The missing heiress was your patient — and she came to you the night she vanished, asking for something you should not have given her. You were the last person to see her alive. You are also not entirely sure she's dead.",
    passport_number: "L7 482 901",
    nationality: "British Citizen",
    date_of_birth: "12 Jun 1968",
    character_sheet_url: "#",
    relationships: [
      "Confidante to Vivian Ashford (the missing heiress)",
      "Estranged from her brother, Damien Plum, the resort's head of security",
      "Owes a personal debt to the bartender, Marco Lin",
      "Suspicious of the concierge, Helena Voss, who knows more than she lets on",
    ],
  },
};
